import { observer } from "mobx-react-lite";
import "./LawyerDashboard.scss";
import useTranslation from "../../../hooks/useTranslation";
import CaseItem from "../../../components/Cases/CaseItem";
import { Link, useNavigate } from "react-router-dom";
import { UserRoles } from "../../../stores/AuthStore/types";
import OffersSummary from "../../../components/Offer/OffersSummary";
import caseStore from "../../../stores/CaseStore";
import offerStore from "../../../stores/OfferStore";
import { Card, Tooltip } from "@mui/material";
import configStore from "../../../stores/ConfigStore";
import UserCases from "../../UserCases";
import authStore from "../../../stores/AuthStore";

const LawyerDashboard = observer(() => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="lawyerCasesSummaryContainer">
      <Card elevation={1} className="pl mb" onClick={() => navigate("/cases")}>
        <h4>
          <Link to="/cases">
            <i
              className="fal fa-external-link"
              style={{ fontSize: "14px", marginRight: "5px" }}
            />
            <Tooltip
              title={t("your-case-limit", [
                `${configStore.appConfig.caseLimit}`,
              ])}
              placement={"top-start"}
            >
              <span>
                {t("your-partnerships")} ({caseStore.userCases.length} /{" "}
                {configStore.appConfig.caseLimit})
              </span>
            </Tooltip>
          </Link>
        </h4>
        <div className="userCasesSummaryContainer">
          {caseStore.userCases.length > 0 ? (
            <UserCases summaryMode={true} />
          ) : (
            <div>
              <p
                className="mt0 pt0"
                dangerouslySetInnerHTML={{
                  __html: t("greet-lawyer", [authStore.user?.firstName || ""]),
                }}
              />
            </div>
          )}
        </div>
      </Card>
      <Card
        elevation={1}
        className="pl mb2x"
        onClick={() => navigate("/offers")}
      >
        <h4>
          <Link to="/offers">
            <i
              className="fal fa-external-link"
              style={{ fontSize: "14px", marginRight: "5px" }}
            />
            <span>
              {t("your-offers")} ({offerStore.lawyerOffers.length})
            </span>
          </Link>
        </h4>
        <OffersSummary rawOffers={offerStore.lawyerOffers} summaryMode={true} />
      </Card>

      <h3 className="pt">
        <i className="fal fa-users" /> {t("citizen-cases")}
      </h3>
      <div className="citizenCases">
        {caseStore.caseSearchResult.map((caseItem) => (
          <CaseItem key={caseItem.id} caseItem={caseItem} />
        ))}
      </div>

      <div className="seeMore">
        <Link to={`/search/${UserRoles.USER}`}>
          {t("see-more-cases-lawyer")}
        </Link>
      </div>

      <h3>
        <i className="fal fa-suitcase" /> {t("lawyer-cases")}
      </h3>
      <div className="citizenCases">
        {caseStore.delegationSearchResult.map((caseItem) => (
          <CaseItem key={caseItem.id} caseItem={caseItem} />
        ))}
      </div>

      <div className="seeMore">
        <Link to={`/search/${UserRoles.LAWYER}`}>
          {t("see-more-cases-lawyer")}
        </Link>
      </div>
    </div>
  );
});

export default LawyerDashboard;
